import { IAddressStep, ICarInfo, IOrderCloseReason } from "./types";
import { IRoute } from "store/api/types";
import { IOrderStatus } from "../DetailsSection/types";

export const initialStatus: IOrderStatus = {
  value: "",
  title: "",
};

export const initialAddressSteps: IAddressStep[] = [
  {
    label: "",
  },
];

export const initialCarInfo: ICarInfo = {
  number: "",
  color: "",
  name: "",
  phone: "",
};

export const orderStatuses = [
  {
    value: "WaitingCarSearch",
    title: "Очікується пошук машини",
  },
  {
    value: "SearchesForCar",
    title: "Виконується пошук машини",
  },
  {
    value: "CarFound",
    title: "Машина знайдена",
  },
  {
    value: "Running",
    title: "Замовлення виконується",
  },
  {
    value: "Canceled",
    title: "Замовлення скасоване",
  },
  {
    value: "Executed",
    title: "Замовлення успішно виконане",
  },
  {
    value: "CostCalculation",
    title: "Прорахунок",
  },
];

export const orderCloseReason: IOrderCloseReason[] = [
  {
    value: 0,
    description: "Виконано",
  },
  {
    value: 1,
    description: "Відмова клієнта",
  },
  {
    value: 2,
    description: "Скасовано диспетчером",
  },
  {
    value: 3,
    description: "Скасовано диспетчером",
  },
  {
    value: 4,
    description: "Немає машини",
  },
  {
    value: 5,
    description: "Скасовано диспетчером",
  },
  {
    value: 6,
    description: "Відмова клієнта, не влаштовує тариф",
  },
  {
    value: 7,
    description: "Відмова клієнта, не влаштував час",
  },
];

export const orderClientCancelResult: IOrderCloseReason[] = [
  {
    value: 0,
    description: "Замовлення не вдалося скасувати",
  },
  {
    value: 1,
    description: "Замовлення скасоване",
  },
  {
    value: 2,
    description: "Вимагає підтвердження клієнтом скасування в диспетчерську",
  },
];

export const timeToCloseOrder = 30;

export const findOrderStatus = (value: string) => {
  return orderStatuses.find((order) => order.value === value);
};

export const findCancelOrderResult = (value: number) => {
  return orderClientCancelResult.find((result) => result.value === value);
};

export const makeAddressSteps = (arr: IRoute[]) =>
  arr.map((obj) => ({
    label: `${obj.name} ${obj.number || ""}`,
  }));

export const parseCarInfo = (input: string) => {
  const [number, color, name, phone] = input.split(", ");
  return {
    number,
    color,
    name,
    phone,
  };
};

export const hasSomeMinutesPassed = (
  requiredTime: string,
  minutes: number,
): boolean => {
  const requiredTimeDate = new Date(requiredTime).getTime();
  const currentTime = new Date().getTime();
  const diffMinutes = (currentTime - requiredTimeDate) / (1000 * 60);
  return diffMinutes > minutes;
};
